import Client from './Client';

export type LanguageToolReplacement = {
    value: string;
};

export type LanguageToolMatch = {
    message: string;
    shortMessage?: string;
    offset: number;
    length: number;
    replacements: LanguageToolReplacement[];
    rule?: {
        id?: string;
        description?: string;
        issueType?: string;
    };
};

export type LanguageToolCheckResult = {
    matches: LanguageToolMatch[];
    language?: {
        name?: string;
        code?: string;
        detectedLanguage?: {
            name?: string;
            code?: string;
        };
    };
};

class LanguageTool extends Client {
    check(text: string, language?: string): Promise<LanguageToolCheckResult> {
        const body: AnyObj = { text };
        if (language)
            body.language = language;

        return this.POST(`/plugins/languagetool/check`, body)
            .then(async (response) => {
                let json: AnyObj = {};
                try {
                    json = await response.json();
                } catch (_e) {
                    json = {};
                }
                if (!response.ok)
                    throw new Error(json?.err || `LanguageTool check failed (${response.status})`);

                return {
                    matches: Array.isArray(json.matches) ? json.matches : [],
                    language: json.language,
                } as LanguageToolCheckResult;
            });
    }
}

const LanguageToolApi = new LanguageTool();

export default LanguageToolApi;
